import React from 'react';
import { linkify } from 'utils/linkify';
import styles from './LinkifiedText.module.css';

const LinkifiedText = ({ text }: { text: string }) => (
  <>
    {
      linkify(text).map((segment, index) => (
        segment.type === 'link' ? (
          <a
            className={styles.link}
            href={segment.href}
            key={`${segment.href}-${index}`}
            onClick={event => event.stopPropagation()}
            rel="noopener noreferrer"
            target="_blank"
          >
            {segment.value}
          </a>
        ) : (
          <React.Fragment key={`text-${index}`}>
            {segment.value}
          </React.Fragment>
        )
      ))
    }
  </>
);

export default LinkifiedText;
